import { FilterProps } from "../filter-definition";
import { RadioButtonDateFilter } from "../GenericFilters/RadioButtonDateFilter";
import deliveriesDefaultFilters from "./deliveries-default-filters";

export const DeliveriesCreateDateFilter = (props: FilterProps) => (
  <RadioButtonDateFilter
    {...props}
    filterKey="createDate"
    name="Create Date"
    defaultFilterType={deliveriesDefaultFilters.createDateType}
    defaultStartDate={deliveriesDefaultFilters.createDateStartDate}
    defaultEndDate={deliveriesDefaultFilters.createDateEndDate}
  />
);
